"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
var _b, _c;
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateTypeUrl = exports.updateRoundStagesTemplate = exports.setMadeDecisionStatusCalculationId = exports.updateAssetInfo = exports.openTemplateModal = exports.getDefaultStatusCalculation = exports.getDefaultNotify = exports.updateNotifyRoundStageDefault = exports.updateAmountOwner = exports.updateInstructions = exports.updateReviewTitle = exports.updateCurrentRound = exports.removeRoundStage = exports.updateRoundStage = exports.addRoundStages = exports.updatePhase = exports.updateNotifyAssignedReviewers = exports.updateFolder = exports.updateAssets = exports.updateExistingFiles = exports.updateUrl = exports.selectOption = exports.nextModal = exports.selectProject = exports.closeModal = exports.reviewSlice = exports.uploadAsset = exports.updateRound = exports.saveReview = exports.fetchRound = exports.previousModal = exports.updateHistoryPhase = exports.enableNextBtn = exports.disableNextBtn = exports.openModal = exports.reviewModalInitialState = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const lodash_1 = __importStar(require("lodash"));
const pulse_components_1 = require("@pcs/pulse-components");
const utilities_1 = __importStar(require("jsAssets/utilities"));
const uuid_1 = require("uuid");
const constants_1 = require("./constants");
const helper_1 = require("../../../reviews/helper");
const defaultData_1 = require("../../components/ShareForReview/Overview/defaultData");
const helpers_1 = require("../../../asset-detail/helpers");
const constants_2 = require("../sliceTemplate/constants");
const notification_1 = __importDefault(require("../../../reviews/constants/notification"));
const utils_1 = require("../../utils");
const REVIEW_URL = `${helper_1.URLS.app}api/reviews`;
const ROUND_URL = `${helper_1.URLS.app}api/rounds`;
const SAVE_TASK_NOTE_URL = `${helper_1.URLS.app}save-task-note`;
exports.reviewModalInitialState = {
    id: null,
    mode: constants_1.MODE.create,
    currentStage: null,
    isOpen: false,
    // title modal
    title: '',
    // title review
    titleReview: '',
    // title review
    instruction: '',
    round: null,
    project: (helper_1.REQUEST === null || helper_1.REQUEST === void 0 ? void 0 : helper_1.REQUEST.job)
        ? {
            value: (_b = helper_1.REQUEST === null || helper_1.REQUEST === void 0 ? void 0 : helper_1.REQUEST.job) === null || _b === void 0 ? void 0 : _b.jobId,
            label: (_c = helper_1.REQUEST === null || helper_1.REQUEST === void 0 ? void 0 : helper_1.REQUEST.job) === null || _c === void 0 ? void 0 : _c.jobTitle,
        }
        : null,
    isInsideProject: false,
    // phase
    phase: constants_1.PHASE.startReview,
    // record each phase
    historyPhases: [],
    url: {
        urls: [''],
        combineProof: false,
        // isValid is true because form still progress when url is empty
        isValid: true,
        type: 'web-static',
    },
    // new upload asset
    assets: [],
    folder: null,
    // selected existing files
    existingFiles: [],
    // the review will base to this method to know create or update for it
    method: constants_1.METHOD.startReview,
    notifyAssignedReviewer: false,
    allowNext: false,
    roundStages: (0, defaultData_1.createReviewStagesCurrentUser)(),
    assetIds: [],
    amountOwner: 1,
    assetsInfo: [],
    // true if round data is fetched
    fetchedRound: false,
    isReload: false,
};
exports.openModal = (0, toolkit_1.createAction)('review/openModal');
exports.disableNextBtn = (0, toolkit_1.createAction)('review/disableNextBtn');
exports.enableNextBtn = (0, toolkit_1.createAction)('review/enableNextBtn');
exports.updateHistoryPhase = (0, toolkit_1.createAction)('review/updateHistoryPhase');
exports.previousModal = (0, toolkit_1.createAction)('review/previousModal');
exports.fetchRound = (0, toolkit_1.createAsyncThunk)('review/fetchRound', async (roundId) => {
    const response = await utils_1.v2EndpointCustom
        .get(`${ROUND_URL}/${roundId}`)
        .then((res) => {
        return res.data;
    });
    return response;
});
const saveActivityTaskNoteReview = (jobId = 0, taskId = 0) => {
    const uppercaseFirstLetterArray = helper_1.USER_NAME.toLowerCase()
        .split(' ')
        .map((word) => {
        return word[0].charAt(0).toUpperCase() + word.substring(1);
    });
    const userName = uppercaseFirstLetterArray.join(' ');
    return pulse_components_1.v2Endpoint.post(`${SAVE_TASK_NOTE_URL}`, {
        action: 'tasks',
        type: 'save-task-note',
        job: jobId,
        task: taskId,
        notes: `Review created by: ${userName || ''}`,
    }, {
        headers: {
            'Content-Type': 'application/vnd.api+json',
            Accept: 'application/vnd.api+json',
        },
    });
};
const saveRoundTaskForm = (roundId = 0, ticketId = 0, jobId = 0) => {
    return pulse_components_1.v2Endpoint
        .post(`${ROUND_URL}/${roundId}/tickets`, {
        ticket_ids: [ticketId],
    }, {
        headers: {
            'Content-Type': 'application/vnd.api+json',
            Accept: 'application/vnd.api+json',
        },
    })
        .then(async ({ status, data }) => {
        if (status === 200) {
            await saveActivityTaskNoteReview(jobId, ticketId);
        }
        return data;
    });
};
exports.saveReview = (0, toolkit_1.createAsyncThunk)('review/saveReview', async ({ review, ticketId }) => {
    var _a, _b, _c, _d, _e;
    try {
        const response = await pulse_components_1.v2Endpoint.request({
            method: pulse_components_1.METHODS.POST,
            url: `${REVIEW_URL}`,
            data: review,
            headers: {
                'Content-Type': 'application/vnd.api+json',
                Accept: 'application/vnd.api+json',
            },
        });
        if (response.data) {
            const { data } = response;
            const { rounds } = (_a = data === null || data === void 0 ? void 0 : data.data) === null || _a === void 0 ? void 0 : _a.attributes;
            const jobId = ((_c = (_b = data === null || data === void 0 ? void 0 : data.data) === null || _b === void 0 ? void 0 : _b.attributes) === null || _c === void 0 ? void 0 : _c.job_id) || 0;
            if (rounds.length && ticketId) {
                const IdLastRound = ((_d = rounds[rounds.length - 1]) === null || _d === void 0 ? void 0 : _d.id) || 0;
                await saveRoundTaskForm(IdLastRound, ticketId, jobId);
            }
            return data.data.attributes;
        }
    }
    catch (err) {
        const axiosErr = err;
        if (((_e = axiosErr === null || axiosErr === void 0 ? void 0 : axiosErr.response) === null || _e === void 0 ? void 0 : _e.status) === 422) {
            return axiosErr.response;
        }
        throw err;
    }
});
exports.updateRound = (0, toolkit_1.createAsyncThunk)('review/updateRound', async (round) => {
    const response = await pulse_components_1.v2Endpoint.request({
        method: pulse_components_1.METHODS.PATCH,
        url: `${ROUND_URL}/${round.data.id}`,
        data: round,
        headers: {
            'Content-Type': 'application/vnd.api+json',
            Accept: 'application/vnd.api+json',
        },
    });
    return { data: response.data, status: 'update round success' };
});
exports.uploadAsset = (0, toolkit_1.createAsyncThunk)('review/uploadAsset', async (files, { getState }) => {
    const { review: { folder, project }, } = getState();
    utilities_1.default.blockPage();
    const arr = await Promise.all(files.map(async (asset) => {
        const { latestAssetId } = await (0, helpers_1.handleUploadAttachment)(asset, project === null || project === void 0 ? void 0 : project.value, folder === null || folder === void 0 ? void 0 : folder.value);
        return latestAssetId;
    }));
    utilities_1.default.unblockPage();
    return arr;
});
/* eslint-disable no-param-reassign */
exports.reviewSlice = (0, toolkit_1.createSlice)({
    name: 'review',
    initialState: exports.reviewModalInitialState,
    reducers: {
        closeModal: () => exports.reviewModalInitialState,
        selectProject: (state, action) => {
            state.project = action.payload
                ? {
                    ...state.project,
                    ...action.payload,
                }
                : null;
        },
        updateUrl: (state, action) => {
            state.url = action.payload;
        },
        updateTypeUrl: (state, action) => {
            // is web-static
            state.url.type = action.payload ? 'web-dynamic' : 'web-static';
        },
        selectOption: (state, action) => {
            state.currentStage = action.payload;
        },
        updateExistingFiles: (state, actions) => {
            state.existingFiles = actions.payload;
        },
        updateAssets: (state, actions) => {
            state.assets = [...actions.payload];
        },
        updateFolder: (state, actions) => {
            state.folder = actions.payload;
        },
        nextModal: (state) => {
            const { phase } = state;
            switch (phase) {
                case constants_1.PHASE.startReview:
                    if (state.project) {
                        state.phase = constants_1.PHASE.selectOption;
                    }
                    break;
                case constants_1.PHASE.confirmCreateNewRound: {
                    const { round } = state;
                    const roundSource = Array.isArray(round === null || round === void 0 ? void 0 : round.source)
                        ? round === null || round === void 0 ? void 0 : round.source[0]
                        : round === null || round === void 0 ? void 0 : round.source;
                    /**
                     * also keep this block, maybe change business
                     */
                    // const sourceType = roundSource?.type;
                    // const sourceUrl = roundSource?.url;
                    // if (state.round && sourceType !== SOURCE_TYPE.asset) {
                    //   state.phase = PHASE.chooseUrl;
                    //   state.url.urls[0] = sourceUrl || '';
                    //   break;
                    // }
                    state.phase = constants_1.PHASE.selectOption;
                    state.historyPhases.push(constants_1.PHASE.selectOption);
                    break;
                }
                case constants_1.PHASE.selectOption:
                    // clear assets
                    state.assetIds = [];
                    if (state.currentStage === constants_1.OPTION.existing) {
                        state.currentStage = constants_1.OPTION.existing;
                        state.phase = constants_1.PHASE.chooseExisting;
                    }
                    if (state.currentStage === constants_1.OPTION.url) {
                        state.currentStage = constants_1.OPTION.url;
                        state.phase = constants_1.PHASE.chooseUrl;
                    }
                    if (state.currentStage === constants_1.OPTION.upload) {
                        state.currentStage = constants_1.OPTION.upload;
                        state.phase = constants_1.PHASE.chooseUpload;
                    }
                    if (state.currentStage === constants_1.OPTION.previous) {
                        state.currentStage = constants_1.OPTION.previous;
                        state.phase = constants_1.PHASE.reviewing;
                    }
                    break;
                case constants_1.PHASE.chooseExisting:
                    if (state.existingFiles.length > 0) {
                        state.assetIds = state.existingFiles;
                        state.phase = constants_1.PHASE.reviewing;
                    }
                    break;
                case constants_1.PHASE.chooseUrl:
                    state.url.isValid =
                        (0, helper_1.getIndexUrlDuplicates)(state.url.urls).length === 0 &&
                            state.url.urls.every((item) => (0, helper_1.isReviewUrl)(item));
                    if (state.url.isValid) {
                        state.phase = constants_1.PHASE.reviewing;
                    }
                    break;
                case constants_1.PHASE.reviewing: {
                    state.phase = constants_1.PHASE.savingTemplate;
                    break;
                }
                case constants_1.PHASE.savingTemplate: {
                    state.phase = constants_1.PHASE.templateSettings;
                    break;
                }
                case constants_1.PHASE.templateSettings: {
                    state.phase = constants_1.PHASE.reviewing;
                    break;
                }
                case constants_1.PHASE.updateTemplate: {
                    state.phase = constants_1.PHASE.reviewing;
                    break;
                }
                default:
                    break;
            }
        },
        updateNotifyAssignedReviewers: (state) => {
            state.notifyAssignedReviewer = !state.notifyAssignedReviewer;
        },
        updatePhase: (state, actions) => {
            state.phase = actions.payload;
        },
        addRoundStages: (state) => {
            //  The initial stage will collapsed
            const initialStages = state.roundStages.map((stage) => ({
                ...stage,
                isOpen: false,
            })) || state.roundStages;
            const isFirstRound = initialStages.length > 0 ? helper_1.WHEN : helper_1.IMMEDIATELY;
            const previousStage = initialStages.at(-1);
            const clientId = (0, uuid_1.v4)();
            const newRoundStage = [
                ...initialStages,
                {
                    ...(0, defaultData_1.newStageDefault)(state.roundStages.length + 1 || 1),
                    clientId,
                    stageStatusStrategy: state === null || state === void 0 ? void 0 : state.defaultStatusCalculation,
                    triggerTypeId: isFirstRound,
                    parentStageId: previousStage === null || previousStage === void 0 ? void 0 : previousStage.clientId,
                },
            ];
            state.roundStages = newRoundStage;
        },
        updateRoundStage: (state, action) => {
            // when we update any stage, the stage of round is confirmed that it is modified
            let defaultStage = false;
            // the default is not modified if we open or close Accordion
            const keyUpdate = Object.keys(action.payload.valueUpdate);
            if (keyUpdate.includes('isOpen') && (0, helper_1.isDefaultStage)(state.roundStages)) {
                defaultStage = true;
            }
            // update stage
            state.roundStages[action.payload.indexStage] = {
                ...state.roundStages[action.payload.indexStage],
                isDefaultStage: defaultStage,
                ...action.payload.valueUpdate,
            };
        },
        updateNotifyRoundStageDefault: (state) => {
            const initStage = (0, defaultData_1.createReviewStagesCurrentUser)().map((stage) => {
                var _a;
                return {
                    ...stage,
                    stageStatusStrategy: state === null || state === void 0 ? void 0 : state.defaultStatusCalculation,
                    members: (_a = stage.members) === null || _a === void 0 ? void 0 : _a.map((member) => {
                        return {
                            ...member,
                            roundStageNotificationType: state === null || state === void 0 ? void 0 : state.defaultNotification,
                        };
                    }),
                };
            });
            state.roundStages = initStage;
        },
        getDefaultNotify: (state, action) => {
            state.defaultNotification = {
                ...action.payload,
            };
        },
        getDefaultStatusCalculation: (state, action) => {
            state.defaultStatusCalculation = {
                ...action.payload,
            };
        },
        removeRoundStage: (state, action) => {
            state.roundStages.splice(action.payload, 1);
        },
        updateCurrentRound: (state, action) => {
            state.round = (0, lodash_1.assign)(state.round, action.payload.valueUpdate);
        },
        updateReviewTitle: (state, action) => {
            state.titleReview = action.payload;
        },
        updateInstructions: (state, action) => {
            state.instruction = action.payload;
        },
        updateRoundStagesTemplate: (state, action) => {
            var _a, _b;
            let newStages = (_a = action.payload) === null || _a === void 0 ? void 0 : _a.stages;
            if (((_b = action.payload) === null || _b === void 0 ? void 0 : _b.action) === 'append') {
                newStages = state.roundStages.concat(newStages);
            }
            state.roundStages = newStages;
        },
        updateAmountOwner: (state) => {
            const { round, roundStages } = state;
            let countOwner = 0;
            roundStages.forEach((stage) => {
                var _a;
                return (_a = stage.members) === null || _a === void 0 ? void 0 : _a.forEach((member) => {
                    if ((member.id || member.userid) === (round === null || round === void 0 ? void 0 : round.ownerId)) {
                        countOwner += 1;
                    }
                });
            });
            state.amountOwner = countOwner;
        },
        openTemplateModal: (state, action) => {
            if (action.payload === constants_2.SAVING_METHOD.saveAsNew) {
                state.phase = constants_1.PHASE.templateSettings;
            }
            if (action.payload === constants_2.SAVING_METHOD.updateExisting) {
                state.phase = constants_1.PHASE.updateTemplate;
            }
        },
        updateAssetInfo: (state, action) => {
            state.assetsInfo = action.payload;
        },
        setMadeDecisionStatusCalculationId: (state, action) => {
            state.madeDecisionStatusCalculation = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(exports.disableNextBtn, (state) => {
            state.allowNext = false;
        })
            .addCase(exports.enableNextBtn, (state) => {
            state.allowNext = true;
        })
            .addCase(exports.openModal, (state, action) => {
            var _a, _b, _c, _d;
            // default open
            state.mode = action.payload.status;
            state.isOpen = true;
            const roundStage = action.payload.round || null;
            // MODE create
            if (action.payload.status === constants_1.MODE.create) {
                state.project =
                    action.payload.id && action.payload.label
                        ? {
                            value: action.payload.id,
                            label: action.payload.label,
                        }
                        : null;
                state.isInsideProject = !!action.payload.id;
                state.phase = action.payload.id
                    ? constants_1.PHASE.selectOption
                    : constants_1.PHASE.startReview;
            }
            // MODE new round
            if (action.payload.status === constants_1.MODE.newRound) {
                state.project =
                    (roundStage === null || roundStage === void 0 ? void 0 : roundStage.job_id) && (roundStage === null || roundStage === void 0 ? void 0 : roundStage.job_title)
                        ? {
                            value: roundStage === null || roundStage === void 0 ? void 0 : roundStage.job_id,
                            label: roundStage === null || roundStage === void 0 ? void 0 : roundStage.job_title,
                        }
                        : null;
                state.round = action.payload;
                state.phase = constants_1.PHASE.confirmCreateNewRound;
            }
            // MODE Share for review ( share is create new review and update is update this review)
            if (action.payload.status === constants_1.MODE.share) {
                if (action.payload.id) {
                    state.assetIds = [(0, lodash_1.parseInt)(action.payload.id)];
                }
                if (((_a = action.payload) === null || _a === void 0 ? void 0 : _a.jobId) && ((_b = action.payload) === null || _b === void 0 ? void 0 : _b.label)) {
                    state.project = {
                        value: (_c = action.payload) === null || _c === void 0 ? void 0 : _c.jobId,
                        label: (_d = action.payload) === null || _d === void 0 ? void 0 : _d.label,
                    };
                }
                state.phase = constants_1.PHASE.reviewing;
            }
            // MODE update
            if (action.payload.status === constants_1.MODE.update) {
                state.phase = constants_1.PHASE.reviewing;
            }
            state.round = (0, lodash_1.assign)(roundStage, defaultData_1.INITIAL_OWNER);
            state.title = constants_1.MODE_LABEL[action.payload.status];
            if (action.payload.isReload) {
                state.isReload = action.payload.isReload;
            }
            // if open in the task form
            state.ticketId = action.payload.ticketId;
        })
            .addCase(exports.updateHistoryPhase, (state) => {
            if (state.historyPhases.includes(state.phase)) {
                const phaseIndex = state.historyPhases.indexOf(state.phase);
                const lengthHistoryPhases = state.historyPhases.length;
                const amountPhasesRemove = lengthHistoryPhases - phaseIndex - 1;
                state.historyPhases = (0, lodash_1.dropRight)(state.historyPhases, amountPhasesRemove);
                return;
            }
            state.historyPhases.push(state.phase);
            // when phase is update, btn next will disable
            if (state.phase !== constants_1.PHASE.updateTemplate &&
                state.phase !== constants_1.PHASE.templateSettings) {
                state.allowNext = false;
            }
        })
            .addCase(exports.uploadAsset.fulfilled, (state, action) => {
            state.assetIds = action.payload;
            state.phase = constants_1.PHASE.reviewing;
        })
            .addCase(exports.fetchRound.fulfilled, (state, action) => {
            var _a;
            const roundRes = (0, utilities_1.camelizeKeys)((0, utilities_1.parseJsonApi)(action.payload));
            const currentRound = (0, helper_1.parseCurrentRoundState)(roundRes);
            const currentStages = (0, helper_1.parseRoundStagesState)(roundRes.stages, state.mode);
            state.project = { value: roundRes.jobId, label: roundRes.jobTitle };
            state.id = roundRes.reviewId;
            state.round = currentRound;
            state.roundStages = currentStages;
            state.instruction = (currentRound === null || currentRound === void 0 ? void 0 : currentRound.instruction) || '';
            state.phase = constants_1.PHASE.reviewing;
            let countOwner = 0;
            if (roundRes === null || roundRes === void 0 ? void 0 : roundRes.roundSources) {
                // use sources to prefill url/asset info
                roundRes === null || roundRes === void 0 ? void 0 : roundRes.roundSources.forEach((src) => {
                    if (src.type === 'asset' && src.asset) {
                        if ((state.mode === constants_1.MODE.newRound &&
                            state.currentStage === constants_1.OPTION.previous) ||
                            state.mode === constants_1.MODE.update) {
                            state.assetIds = (0, lodash_1.uniq)([...state.assetIds, src.asset.id]);
                        }
                    }
                    if (src.type !== 'asset' &&
                        src.url &&
                        (state.currentStage === constants_1.OPTION.previous ||
                            state.mode === constants_1.MODE.update)) {
                        state.url.urls = [src.url];
                        state.url.type = src.type;
                        state.currentStage =
                            state.currentStage === constants_1.OPTION.previous
                                ? constants_1.OPTION.previous
                                : constants_1.OPTION.url;
                    }
                });
                if (state.currentStage === constants_1.OPTION.existing ||
                    state.currentStage === constants_1.OPTION.upload) {
                    if (currentRound && state.round) {
                        state.round.source = (_a = currentRound.source) === null || _a === void 0 ? void 0 : _a.map((source) => {
                            return {
                                ...source,
                                type: constants_1.SOURCE_TYPE.asset,
                            };
                        });
                    }
                    state.url = exports.reviewModalInitialState.url;
                }
            }
            // count owner
            currentStages.forEach((stage) => {
                var _a;
                return (_a = stage.members) === null || _a === void 0 ? void 0 : _a.forEach((member) => {
                    if (member.id === (currentRound === null || currentRound === void 0 ? void 0 : currentRound.ownerId)) {
                        countOwner += 1;
                    }
                });
            });
            state.amountOwner = countOwner;
            state.titleReview = (currentRound === null || currentRound === void 0 ? void 0 : currentRound.title) || '';
            state.project = {
                value: currentRound === null || currentRound === void 0 ? void 0 : currentRound.jobId,
                label: currentRound === null || currentRound === void 0 ? void 0 : currentRound.label,
            };
            // confirmed that we have got round
            state.fetchedRound = true;
        })
            .addCase(exports.previousModal, (state) => {
            const currentPhase = state.historyPhases.pop();
            if (lodash_1.default.difference(state.historyPhases, [currentPhase])) {
                const lastIndexPhasePrevious = state.historyPhases.length - 1;
                state.phase = state.historyPhases[lastIndexPhasePrevious];
            }
        })
            .addCase(exports.saveReview.fulfilled, (state, payload) => {
            if (state.mode === constants_1.MODE.newRound) {
                if (window.location.hash) {
                    const roundNumber = window.location.hash.split('-')[1];
                    if (Number(roundNumber)) {
                        const hash = `${window.location.hash.split('-')[0]}-${Number(roundNumber) + 1}`;
                        if (Array.isArray(payload.payload.rounds)) {
                            const latestRound = payload.payload.rounds.length;
                            window.location.hash = hash;
                            window.history.pushState({
                                roundId: payload.payload.rounds[latestRound - 1].id,
                            }, '');
                        }
                    }
                }
            }
        })
            // pending api
            .addMatcher((0, toolkit_1.isAnyOf)(exports.fetchRound.pending, exports.saveReview.pending, exports.updateRound.pending), () => {
            utilities_1.default.blockPage();
        })
            // fulfilled api
            .addMatcher((0, toolkit_1.isAnyOf)(exports.saveReview.fulfilled, exports.updateRound.fulfilled), (state, action) => {
            var _a, _b;
            const { type, payload } = action;
            const { data, status } = payload;
            if (status && Number(status) === 422) {
                utilities_1.default.notification.danger((_b = (_a = data === null || data === void 0 ? void 0 : data.errors[0]) === null || _a === void 0 ? void 0 : _a.detail) !== null && _b !== void 0 ? _b : notification_1.default.saveReviewFailed);
                return;
            }
            if (!(type === null || type === void 0 ? void 0 : type.includes('fetchRound'))) {
                let notificationContent = (type === null || type === void 0 ? void 0 : type.includes('updateRound'))
                    ? notification_1.default.updatedRound
                    : notification_1.default.createdReview;
                if (state.mode === constants_1.MODE.newRound) {
                    notificationContent = notification_1.default.updatedNewRound;
                }
                utilities_1.default.notification.success(notificationContent);
            }
            utilities_1.default.unblockPage();
        })
            // rejected api
            .addMatcher((0, toolkit_1.isAnyOf)(exports.fetchRound.rejected, exports.saveReview.rejected, exports.updateRound.rejected), (state, action) => {
            const { type } = action;
            let notifyContent = notification_1.default.saveReviewFailed;
            if (type === null || type === void 0 ? void 0 : type.includes('fetchRound')) {
                notifyContent = notification_1.default.loadRoundFailed;
            }
            if (type === null || type === void 0 ? void 0 : type.includes('updateRound')) {
                notifyContent = notification_1.default.updateRoundFailed;
            }
            if ((type === null || type === void 0 ? void 0 : type.includes('saveReview')) && state.mode === constants_1.MODE.newRound) {
                notifyContent = notification_1.default.updateNewRoundFailed;
            }
            utilities_1.default.notification.danger(notifyContent);
        })
            .addMatcher((0, toolkit_1.isAnyOf)(exports.openModal), (state) => {
            if (constants_1.MODE.update === state.mode) {
                state.method = constants_1.METHOD.updateReview;
            }
        })
            // clear asset info if previous btn is trigger at review setting component
            .addMatcher((0, toolkit_1.isAllOf)(exports.previousModal), (state) => {
            if (state.phase === constants_1.PHASE.chooseUpload ||
                state.phase === constants_1.PHASE.chooseExisting) {
                state.assetsInfo = [];
            }
        });
    },
});
_a = exports.reviewSlice.actions, exports.closeModal = _a.closeModal, exports.selectProject = _a.selectProject, exports.nextModal = _a.nextModal, exports.selectOption = _a.selectOption, exports.updateUrl = _a.updateUrl, exports.updateExistingFiles = _a.updateExistingFiles, exports.updateAssets = _a.updateAssets, exports.updateFolder = _a.updateFolder, exports.updateNotifyAssignedReviewers = _a.updateNotifyAssignedReviewers, exports.updatePhase = _a.updatePhase, exports.addRoundStages = _a.addRoundStages, exports.updateRoundStage = _a.updateRoundStage, exports.removeRoundStage = _a.removeRoundStage, exports.updateCurrentRound = _a.updateCurrentRound, exports.updateReviewTitle = _a.updateReviewTitle, exports.updateInstructions = _a.updateInstructions, exports.updateAmountOwner = _a.updateAmountOwner, exports.updateNotifyRoundStageDefault = _a.updateNotifyRoundStageDefault, exports.getDefaultNotify = _a.getDefaultNotify, exports.getDefaultStatusCalculation = _a.getDefaultStatusCalculation, exports.openTemplateModal = _a.openTemplateModal, exports.updateAssetInfo = _a.updateAssetInfo, exports.setMadeDecisionStatusCalculationId = _a.setMadeDecisionStatusCalculationId, exports.updateRoundStagesTemplate = _a.updateRoundStagesTemplate, exports.updateTypeUrl = _a.updateTypeUrl;
exports.default = exports.reviewSlice.reducer;
